import React from "react";
import { Box, ListItem, ListItemIcon, ListItemText, Typography, Chip, LinearProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DeleteIcon from "@iconify/icons-mdi/delete";
import FileDocumentIcon from "@iconify/icons-mdi/file-document";
import { InlineIcon } from "@iconify/react";
import { getFormatTextWidthValue } from "oc/utils";

export interface OcFileListItemProps {
  filename: string;
  error?: string;
  onDelete?: () => void;
  uploadProgress?: number;
  chip?: string;
  isMobile?: boolean;
  uploadFailed?: boolean;
  id?: string;
}

export const OcFileListItem: React.FC<OcFileListItemProps> = ({
  filename,
  error,
  onDelete,
  uploadProgress,
  chip,
  isMobile = false,
  uploadFailed = false,
  id,
}) => {
  const theme = useTheme();
  const hasError = !!error;
  const isUploading = uploadProgress !== undefined && uploadProgress < 100;

  return (
    <ListItem
      sx={{
        backgroundColor: uploadFailed ? "#FFEBEE" : theme.palette.gray20.main,
        mb: 1,
        borderRadius: "8px",
        border: hasError || uploadFailed ? "1px solid #CC0033" : "1px solid #C6CACC",
      }}
    >
      <ListItemIcon>
        <InlineIcon
          icon={FileDocumentIcon}
          width="24px"
          style={{ color: "#4d4d4d" }}
        />
      </ListItemIcon>
      <ListItemText
        primary={
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="body1">
              {isMobile ? getFormatTextWidthValue(filename, 20) : filename}
            </Typography>
            {chip && <Chip label={chip} size="small" color="primary" />}
          </Box>
        }
        secondary={
          <>
            {error && (
              <Typography variant="body2" style={{ color: "#CC0033" }}>
                {error}
              </Typography>
            )}
            {isUploading && (
              <Box mt={1}>
                <LinearProgress
                  variant="determinate"
                  value={uploadProgress}
                  color="primary"
                  style={{ borderRadius: "8px" }}
                />
                <Typography variant="caption" style={{ color: "#919699", marginTop: "4px" }}>
                  {uploadProgress}% done
                </Typography>
              </Box>
            )}
          </>
        }
      />
      {onDelete && (
        <InlineIcon
          icon={DeleteIcon}
          width="24px"
          style={{ color: "#4d4d4d", cursor: "pointer" }}
          onClick={onDelete}
          id={id}
        />
      )}
    </ListItem>
  );
};

export default OcFileListItem;
